import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { switchMap, take, catchError, filter, map, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { selectAvailabilityList, selectStore } from '@store/selectors';
import { Availability, Menu, Store as StoreModel, Subcategory } from '@core/models';
import { IResponseSuccess } from '@core/interfaces';
import { subcategoryProcessor } from '@core/domain/menu';

@Injectable({
	providedIn: 'root',
})
export class SubcategoryService {
	store$: Observable<StoreModel | null>;
	availabilityList$: Observable<Availability[] | null>;

	constructor(
		private http: HttpClient,
		private store: Store<AppState>
	) {
		this.store$ = this.store.select(selectStore);
		this.availabilityList$ = this.store.select(selectAvailabilityList);
	}

	getSubcategories(localChannelId: string, menu: Menu | null): Observable<IResponseSuccess<Subcategory>> {
		return this.store$.pipe(
			filter(store => !!store),
			filter(menu => !!menu),
			take(1),
			switchMap(store => {
				return this.http.get<IResponseSuccess<Subcategory>>(`${environment.microConfiguraciones}/subcategorias`, {
					params: {
						localId: store.idLocal,
						localCanalId: localChannelId,
						menuId: menu?.idMenu as string,
					},
					headers: {
						authorization: store.apiKey,
					},
				});
			}),
			withLatestFrom(this.availabilityList$),
			map(([response, availabilityList]) => {
				return {
					...response,
					data: subcategoryProcessor.processHome(
						response?.data ?? [],
						availabilityList ?? []
					)
				}
			}),
			catchError(error => {
				return throwError(() => error);
			})
		);
	}
}
